__turbopack_context__.v({
  "container": "-NW29q_container",
  "content": "-NW29q_content",
});
